// put commonly used selectors here to be used across application
import lodash from 'lodash';
import { createSelector } from 'reselect';
import { userDefaultInstitutionIdSelector, binderInstitutionIdSelector } from 'common/selectors';

const isReloading = state => lodash.get(state, 'reloading', false);
export const loadingMeSelector = state => lodash.get(state, 'app.loadingMe', true) || isReloading(state);
export const loadingBinderSelector = state => lodash.get(state, 'app.loadingBinder', true) || isReloading(state);
export const loadingIndexDocumentSelector = state => lodash.get(state, 'app.loadingIndexDocument', true) || isReloading(state);

export const meSelector = state => lodash.get(state, 'me', {});
export const defaultInstitutionSystemPermissionsSelector = state => getDefaultInstitutionSystemPermissions(state);
export const binderSelector = state => lodash.get(state, 'binder', {});

export const binderPermissionsSelector = state => lodash.get(state, 'me.binderPermissions', {});
export const studyPermissionsSeclector = state => lodash.get(state, 'me.studyPermissions', {});
export const manageDoALogSelector = state => getSystemPermissionOfBinderInstitution(state, 'manageDoALog');
export const getSIPStatusPermission = state => getSystemPermissionOfBinderInstitution(state, 'manageSIPStatus');

export const manageTasksSelector = (state, binderInstitutionId = null) => {
    const permissionKey = 'manageTasks';
    const institutionId = binderInstitutionId ? binderInstitutionId : binderInstitutionIdSelector(state);
    return checkInstitutionPermissionsPermissionKey(state, institutionId, permissionKey);
};

const getDefaultInstitutionSystemPermissions = (state) => {
    const institutionId = userDefaultInstitutionIdSelector(state);
    return lodash.get(state, `me.institutionPermissions.${institutionId}`, false);
};

const getSystemPermissionOfBinderInstitution = (state, permissionKey) => {
    const institutionId = binderInstitutionIdSelector(state);
    return checkInstitutionPermissionsPermissionKey(state, institutionId, permissionKey);
};

const checkInstitutionPermissionsPermissionKey = (state, institutionId, permissionKey) => {
    return lodash.get(state, `me.institutionPermissions.${institutionId}.${permissionKey}`, false);
};

export const indexDocumentPermissionsSelector = state => {
    return {
        documentTypes: lodash.get(state, 'indexDocumentForm.documentTypes'),
        loadingMe: lodash.get(state, 'app.loadingMe')
    };
};
export const filePermissionsSelector = (state, props) => {
    return {
        location: props.location,
        binderPermissions: binderPermissionsSelector(state),
    };
};

export const binderMenuPermissionsSelector = createSelector(
    [binderPermissionsSelector, binderSelector],
    (binderPermissions, binder) => {
        return { binderPermissions, binder };
    }
);

export const documentTypePermissionsSelector = (state, documentTypeID) => {
    let objDocumentTypes = lodash.get(state, 'me.documentTypes');

    return lodash.get(objDocumentTypes, `${documentTypeID}.permissions.viewPDF`, false);
};

export const isLoggedInUserInternalUserForCurrentBinderSelector = (state) => {
    const binderUsers = lodash.get(state, 'binder.users');
    const userSub = lodash.get(state, 'me.sub');
    const binderUser = lodash.find(binderUsers, (user) => { return lodash.eq(user.sub, userSub); });
    if (lodash.isNil(binderUser)) { return false; }

    const startDate = lodash.get(binderUser, 'binderExpiration.startDate');
    const endDate = lodash.get(binderUser, 'binderExpiration.endDate');
    return lodash.eq(startDate, null) && lodash.eq(endDate, null);
};
